// Questionnaire/clientRequest.ts
export function delFilterFromClientRequest(): void {
    /**
     * Удаляет все свойства из clientRequest, кроме age и client_gender.
     */
    const clientRequestKey = 'clientRequest';
    const clientRequestStr = localStorage.getItem(clientRequestKey);

    if (!clientRequestStr) {
        console.warn(`LocalStorage не содержит ключа "${clientRequestKey}".`);
        return;
    }

    try {
        const clientRequest: any = JSON.parse(clientRequestStr);

        // Проверяем, что clientRequest является объектом
        if (typeof clientRequest !== 'object' || clientRequest === null) {
            console.error(`clientRequest не является корректным объектом.`);
            return;
        }

        // Создаём новый объект с только необходимыми свойствами
        const filteredClientRequest = {
            age: clientRequest.age,
            client_gender: clientRequest.client_gender,
            timezone: clientRequest.timezone,
            therapy_experience: clientRequest.therapy_experience,
        };

        // Сохраняем обновлённый объект обратно в LocalStorage
        localStorage.setItem(clientRequestKey, JSON.stringify(filteredClientRequest));

        console.log(`clientRequest успешно обновлён:`, filteredClientRequest);
    } catch (error) {
        console.error(`Ошибка при обработке clientRequest:`, error);
    }
}

export function delClientRequest(): void {
    /**
     * Полностью удаляет clientRequest из LocalStorage.
     */
    const clientRequestKey = 'clientRequest';

    if (localStorage.getItem(clientRequestKey)) {
        localStorage.removeItem(clientRequestKey);
        console.log(`clientRequest удалён из LocalStorage.`);
    } else {
        console.warn(`LocalStorage не содержит ключа "${clientRequestKey}".`);
    }
}
